import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
import VueWechatTitle from 'vue-wechat-title'
import VueClipboard from 'vue-clipboard2'
import Carousel3d from 'vue-carousel-3d'
import VueLuckyCanvas from '@lucky-canvas/vue'

Vue.use(VueLuckyCanvas)
Vue.use(Carousel3d)
Vue.use(VueClipboard)
Vue.use(VueWechatTitle)
Vue.prototype.$axios = axios

Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
